import { useEffect, useState, useCallback } from 'react'
import { debounce } from 'lodash'
import useWindowDimensions from './useWindowDimensions'

const useDebouncedValue = <T>(value: T, debounceTime = 200) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  const debouncedSetValue = useCallback(
    debounce(val => setDebouncedValue(val), debounceTime),
    []
  )

  useEffect(() => {
    debouncedSetValue(value)
  }, [value])

  return debouncedValue
}

const useOnWindowResizing = (debounceTime = 200) => {
  const window = useWindowDimensions()
  const [resizing, setResizing] = useState(false)

  const debouncedHeight = useDebouncedValue(window.height, debounceTime)
  const debouncedWidth = useDebouncedValue(window.width, debounceTime)

  useEffect(() => {
    setResizing(true)
    const timeout = setTimeout(() => setResizing(false), debounceTime)
    return () => clearTimeout(timeout)
  }, [debouncedHeight, debouncedWidth])

  return resizing
}

export default useOnWindowResizing
